import { render, staticRenderFns } from "./LicitacaoBusca.vue?vue&type=template&id=6b8f7a2d"
import script from "./LicitacaoBusca.vue?vue&type=script&lang=js"
export * from "./LicitacaoBusca.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoBusca.vue?vue&type=style&index=0&id=6b8f7a2d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports